@if (tourService.promptVisible() && content(); as prompt) {
  <div class="tour-prompt" role="dialog" aria-modal="true" aria-labelledby="tour-prompt-title">
    <button
      type="button"
      class="tour-prompt__backdrop"
      aria-label="Close tour prompt"
      (click)="dismiss()"
    ></button>

    <div class="tour-prompt__card">
      <div class="tour-prompt__icon" aria-hidden="true">
        <i [class]="prompt.icon"></i>
      </div>

      <h2 id="tour-prompt-title" class="tour-prompt__title">{{ prompt.title }}</h2>
      <p class="tour-prompt__description">{{ prompt.description }}</p>

      <div class="tour-prompt__actions">
        <p-button
          label="Not now"
          [outlined]="true"
          severity="secondary"
          styleClass="tour-prompt__btn"
          (onClick)="dismiss()"
        ></p-button>
        <p-button
          label="Start tour"
          icon="pi pi-arrow-right"
          iconPos="right"
          styleClass="tour-prompt__btn"
          (onClick)="accept()"
        ></p-button>
      </div>
    </div>
  </div>
}
